import React, { useRef, useMemo, useState } from "react";

import ProductCard from "./ProductCard";
import { ProductGridProps } from "./types";
import Button from "../button/Button";

import styles from "./productGrid.module.css";
import useHasScrolled from "../../utils/useHasScrolled";
import useIsInViewport from "../../utils/useIsInViewport";

interface Props {
  indexOfPreviousProd: number;
}

const ProductGrid = ({
  products,
  indexOfPreviousProd,
}: ProductGridProps & Props): JSX.Element => {
  const loadMoreProductsRef = useRef(null);
  const [productLimit, setProductLimit] = useState<number>(14);
  const [showFromIndex, setShowFromIndex] =
    useState<number>(indexOfPreviousProd);
  const endOfProductsReached = useIsInViewport(loadMoreProductsRef);

  useMemo(() => {
    if (indexOfPreviousProd) {
      setShowFromIndex(indexOfPreviousProd);
    }
  }, [indexOfPreviousProd]);

  const showPreviousProducts = () => {
    setShowFromIndex(showFromIndex - 15);
  };

  useMemo(() => {
    if (endOfProductsReached) {
      setProductLimit(productLimit + 15);
    }
  }, [endOfProductsReached]);

  return (
    <>
      <div className={styles.loadMoreButtonContainer}>
        {showFromIndex > 0 && (
          <Button
            text="Load previous products"
            onClick={showPreviousProducts}
          />
        )}
      </div>
      <div className={styles.container}>
        {!products ||
          (products.length < 1 && (
            <p className={styles.noProductsMessage}>No products found</p>
          ))}
        {showFromIndex
          ? products &&
            products.map((product, index) => {
              if (
                index > showFromIndex + productLimit ||
                index < showFromIndex
              ) {
                return <></>;
              }
              return (
                <div key={product.id} className={styles.productCard}>
                  <ProductCard product={product} index={index} />
                </div>
              );
            })
          : products &&
            products.map((product, index) => {
              if (index > productLimit) {
                return <></>;
              }
              return (
                <div key={product.id} className={styles.productCard}>
                  <ProductCard product={product} index={index} />
                </div>
              );
            })}
      </div>
      <div ref={loadMoreProductsRef}></div>
    </>
  );
};

export default ProductGrid;
